import {
    IMenuItemConfigReader,
    MenuItemAnalyticsCategoryAndLabel,
    MenuItemConfigurationExtended
} from "./menu-item-config-reader.interface";
import {
    MenuItemConfiguration,
    MenuItemsConfiguration
} from "../../configurations/config-data-sections/menu-items.configuration";
import {IServiceFactoryExtended} from "../../service-factory-extended.interface";
import {Check} from "@sparkware/app-utils";
import {AnalyticsConfiguration} from "../../configurations/config-data-sections/analytics.configuration";

export abstract class MenuItemConfigReaderBase implements IMenuItemConfigReader {
    constructor(protected readonly services: IServiceFactoryExtended) {
    }

    protected abstract _getMenuItemsConfigOverrides(): MenuItemsConfiguration | undefined;
    protected abstract _getAnalyticsCategoryAndLabel(): MenuItemAnalyticsCategoryAndLabel | null;

    getMenuItemConfig(key: string): MenuItemConfigurationExtended {
        const allConfigs = this.services.configuration.data;
        const menuItemConfig: MenuItemConfiguration | undefined = allConfigs.menuItems[key];
        if(!menuItemConfig) {
            throw new Error(`Missing configuration for ${key} menu item`);
        }

        const menuItemsOverrides = this._getMenuItemsConfigOverrides();

        const menuItemConfigOverride: MenuItemConfiguration | undefined = menuItemsOverrides && menuItemsOverrides[key];



        const menuItemConfigProxyHandler = {
            get: (target: any, prop: string) => {
                if(prop === 'analytics') {
                    const categoryAndLabel = this._getAnalyticsCategoryAndLabel();
                    if(categoryAndLabel) {
                        const analyticsConfig: AnalyticsConfiguration = {
                            action: key,
                            ...categoryAndLabel
                        }
                        return analyticsConfig;
                    } else {
                        return null;
                    }
                } else {
                    const overridePropValue = menuItemConfigOverride && menuItemConfigOverride[prop];
                    if(Check.isUndefined(overridePropValue)) {
                        return target[prop];
                    } else {
                        return overridePropValue;
                    }
                }
            }
        }

        return new Proxy(menuItemConfig, menuItemConfigProxyHandler);


    }
}

